<template>
  <div class="stock-mfi-view">
    <StockMFI />
  </div>
</template>

<script>
import StockMFI from '@/components/indicators/StockMFI.vue'

export default {
  name: 'StockMFIView',
  components: {
    StockMFI
  }
}
</script>

<style scoped>
.stock-mfi-view {
  min-height: 100vh;
}
</style>
